<template>
	<select :id="id" @change='change' v-model="selected" class='form-control my-control' data-num='f_12' data-table='1' :class='field_class'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const REGION = 'region_list.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'region',
		data: function () { 
			return {
				selected: '0',
				options: [],
				id: `${this.type}_region`,
				k: this.set_id
			}
		},
		props: {
			type: '',
			set_id: '',
			field_class: '',
			region_id: null
		},
		watch: {
			region_id(val) {
				this.selected = val
			}
		},
		methods: {
			fill: function (select) {
				//console.log(id)
				fetch(DB + REGION, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = [{id: '0', name: ''}, ...data]; 
						this.selected = this.region_id ? this.region_id : '0'
					}
					else {
						this.options = []
					}
				})
				.catch(err => console.log(err))
			},
			change: function () {
				EventBus.$emit(`${this.type}_region`, this.selected)
			}
		},
		mounted () {
			this.fill()
		},
	}
</script>


// WEBPACK FOOTER //
// region.vue?78a068ee